import React from "react";
import { useAvelaToast } from "src/hooks/useAvelaToast";
import type { BulkTargets } from "../types";
import { useBulkActionTargets } from "./bulkActionTargetsContext";

export function useRequireBulkTargets() {
  const toast = useAvelaToast();
  const { resolveTargets } = useBulkActionTargets();

  return React.useCallback(async (): Promise<BulkTargets | null> => {
    const result = await resolveTargets();
    if (!result.targets) {
      toast({
        title:
          result.reason === "empty-list"
            ? "No forms in the current list to process."
            : "Please select at least one form to continue.",
        status: "info",
      });
      return null;
    }
    return result.targets;
  }, [resolveTargets, toast]);
}
